import React from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from "react-responsive-carousel"
import "@brainhubeu/react-carousel/lib/style.css"
import { Link, graphql, StaticQuery } from "gatsby"
import "../../Styles/index.scss"
import Img from "gatsby-image"


const leftsliderquery = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        children: {}
        frontmatter: { cat: { eq: "music" }, slider: { eq: true } }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            cat
            artist
            image {
              publicURL
            }
          }
          excerpt(truncate: true)
          fields {
            slug
          }
        }
      }
    }
  }
`

export default class Musicvideoslider extends React.Component {
  render() { 
    return (
      <div className="the-slider">
        <StaticQuery
          query={leftsliderquery}
          render={data => {
            return (
              <div>
                <Carousel  autoPlay interval="5000" transitionTime="1000" style={{height:"100%"}}>
                  {data.allMarkdownRemark.edges.map(({ node }) => (
                    <div>
                       
                      <img
                      className="the-slider-carousel"
                        src={node.frontmatter.image.publicURL}
                        alt="first slide"
                      /><Link to={node.fields.slug}>
                      <h1 className="legend">{node.frontmatter.title} - {node.frontmatter.artist}</h1></Link>
                    </div>
                  ))}
                </Carousel>
              </div>
            )
          }}
        />

      </div>

    )
  }
}
